import { ErrorHandler, Injectable, Injector, inject } from "@angular/core";
import { Router } from "@angular/router";
import { IConfig } from "../interfaces";
import { ToasterService } from "./toaster.service";
import { BehaviorSubject } from "rxjs";
const LOGTAG = "[GlobalErrorHandlerService]";

@Injectable({
  providedIn: "root",
})
export class GlobalsService {
  readonly spinner: any;
  pageData: any;
  showsplash = true;
  loading = false;
  title = "overview";
  breadcrumb: string | undefined = undefined;
  config: IConfig = {
    url: new BehaviorSubject<string>(""),
  };
  widthClass: string = "lg:max-w-[85rem] mx-auto px-5 sm:px-0";  
  activeColor: string = "bg-linear-to-tr from-purple-400 to-indigo-800 text-transparent dark:to-indigo-900";
  activeTextColor: string = "bg-clip-text "+this.activeColor;
  /** Solid border equivalent of activeTextColor — gradients can't apply to border-color, so highlighted borders use this instead. */
  activeBorderColor = "border-purple-600 dark:border-purple-400";
  /** Same, but for hover-only border accents (must stay a literal string — Tailwind's
   * JIT scanner can't see hover:/dark: variants built by concatenating strings at runtime). */
  activeBorderColorHover = "hover:border-purple-200 dark:hover:border-purple-800";

  // widthClass: string = "xl:max-w-7xl mx-auto";
  // /** Gradient background — use on buttons, badges, highlighted sections. */
  // activeColor: string = "btn-primary";
  // /** Gradient text clip — use on headings/spans needing the purple gradient text effect. */
  // activeTextColor: string = "text-gradient";

  readonly router: Router = inject(Router)
  private readonly toast: ToasterService = inject(ToasterService)

  async navigate(path: string, subpage = true) {
    await this.router.navigate([path], { replaceUrl: subpage });
  }

  async toastAlert(
    message: string,
    mode: "warning" | "danger" | "success"
  ) {
    switch (mode) {
      case "warning":
        this.toast.warn(message);
        break;
      case "danger":
        this.toast.error(message);
        break;
      case "success":
        this.toast.success(message);
        break;
      default:
        this.toast.success(message);
        break;
    }
  }
}

@Injectable({
  providedIn: "root",
})
export class GlobalErrorHandlerService implements ErrorHandler {
  // private toasterService = inject(ToasterService);
  constructor(private injector: Injector) {}

  public async handleError(error: unknown) {
    try {
      // const globalService: GlobalsService =
      //   this.injector.get<GlobalsService>(GlobalsService);
      // const message = this.getMessageFromUnknownError(error);
      // console.log(message);
      // await globalService.toastAlert(message, 'error');
    } catch (errorHandlerError) {
      console.error(`${LOGTAG} Internal exception:`, errorHandlerError);
    }
  }

  private getMessageFromUnknownError(error: unknown): string {
    let message = "An unknown error has occurred.";
    if (error instanceof Object && "rejection" in error) {
      error = (error as any).rejection;
    }
    if (error instanceof Error && error.message) {
      message = error.message;
    }
    return message;
  }
}
